import { useState } from 'react';

export interface CommentItemData {
  user: string;
  avatarColor: string;
  content: string;
  likes: number;
  time: string;
  stance: 'support' | 'oppose' | 'neutral';
}

const STANCE_LABEL: Record<CommentItemData['stance'], { text: string; className: string }> = {
  support: { text: '倾向支持', className: 'bg-secondary-100 text-secondary-800' },
  oppose: { text: '持保留', className: 'bg-primary-100 text-primary-800' },
  neutral: { text: '观望', className: 'bg-background-200 text-foreground-700' },
};

export default function CommentFeed({ comments }: { comments: CommentItemData[] }) {
  const [liked, setLiked] = useState<Record<number, boolean>>({});

  const toggleLike = (index: number) => {
    setLiked((prev) => ({ ...prev, [index]: !prev[index] }));
  };

  return (
    <ul className="divide-y divide-background-200/70">
      {comments.map((comment, index) => {
        const stance = STANCE_LABEL[comment.stance];
        const isLiked = Boolean(liked[index]);
        return (
          <li key={`${comment.user}-${index}`} className="py-5 flex gap-4">
            <span
              className={`w-10 h-10 shrink-0 flex items-center justify-center rounded-full text-background-50 font-bold ${comment.avatarColor}`}
            >
              {comment.user.slice(0, 1)}
            </span>
            <div className="flex-1 min-w-0">
              <div className="flex flex-wrap items-center gap-x-3 gap-y-1">
                <span className="text-sm font-bold text-foreground-900">{comment.user}</span>
                <span className={`px-2 py-0.5 rounded-md text-xs ${stance.className}`}>{stance.text}</span>
                <span className="text-xs text-foreground-400">{comment.time}</span>
              </div>
              <p className="mt-2.5 text-sm text-foreground-700 leading-relaxed">{comment.content}</p>
              <div className="mt-3 flex items-center gap-5 text-xs text-foreground-500">
                <button
                  type="button"
                  onClick={() => toggleLike(index)}
                  className={`flex items-center gap-1.5 transition-colors cursor-pointer ${
                    isLiked ? 'text-primary-600' : 'hover:text-primary-600'
                  }`}
                >
                  <i className={isLiked ? 'ri-thumb-up-fill' : 'ri-thumb-up-line'}></i>
                  {comment.likes + (isLiked ? 1 : 0)}
                </button>
                <span className="flex items-center gap-1.5">
                  <i className="ri-chat-3-line"></i>回复
                </span>
                <span className="flex items-center gap-1.5">
                  <i className="ri-share-forward-line"></i>分享
                </span>
              </div>
            </div>
          </li>
        );
      })}
    </ul>
  );
}